import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sccWrapper" }
const _hoisted_2 = { class: "elevation-1 chartWrapper sccCard" }
const _hoisted_3 = { class: "chart-title text-center" }
const _hoisted_4 = {
  key: 0,
  class: "label-abbr-btn"
}
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = {
  key: 2,
  class: "label-abbr-list"
}
const _hoisted_7 = { class: "mr-4" }
const _hoisted_8 = { class: "label-name mr-4" }
const _hoisted_9 = { class: "modal-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_base_chart = _resolveComponent("base-chart")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.noDataAlert,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.noDataAlert) = $event)),
      timeout: 3000,
      color: "primary",
      location: "top"
    }, {
      default: _withCtx(() => [
        _cache[15] || (_cache[15] = _createElementVNode("h3", null, "No data available for this range", -1)),
        _createVNode(_component_v_btn, {
          color: "blue",
          variant: "text",
          class: "d-flex ml-auto",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.noDataAlert = false))
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.pdfTimeoutError,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pdfTimeoutError) = $event)),
      timeout: 3000,
      color: "primary",
      location: "top"
    }, {
      default: _withCtx(() => [
        _cache[17] || (_cache[17] = _createElementVNode("h3", null, "Error downloading requested pdf. Please try again.", -1)),
        _createVNode(_component_v_btn, {
          color: "blue",
          variant: "text",
          class: "d-flex ml-auto",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pdfTimeoutError = false))
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.title) + " segmentation ", 1),
          (_ctx.type === 'string' && !_ctx.isSampleReport)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_btn, {
                  color: "deep-purple accent-3",
                  elevation: "5",
                  variant: "text",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showLabelAbbreviation = true))
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode(" Abbreviate Labels ", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.type == 'string')
            ? (_openBlock(), _createBlock(_component_base_chart, {
                key: 0,
                options: _ctx.chartOptions,
                "scroll-options": _ctx.stringChartSize,
                onClick: _cache[5] || (_cache[5] = (e) => _ctx.chartClick(e)),
                class: "mt-7 ml-0"
              }, null, 8, ["options", "scroll-options"]))
            : (_openBlock(), _createBlock(_component_base_chart, {
                key: 1,
                options: _ctx.chartOptions,
                "scroll-options": _ctx.chartSize,
                onClick: _cache[6] || (_cache[6] = (e) => _ctx.chartClick(e)),
                class: "mt-7 ml-0"
              }, null, 8, ["options", "scroll-options"])),
          (_ctx.type === 'string')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilteredLabelList(_ctx.labelAbbrData), (labelData, key) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            color: "#ccc",
                            class: "abbr-label-item align-center",
                            key: key
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(labelData.labelAbbr) + " - " + _toDisplayString(labelData.labelKey), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.membersDialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.membersDialog) = $event)),
      "onClick:outside": _cache[11] || (_cache[11] = ($event: any) => (_ctx.membersDialog = false)),
      persistent: "",
      "max-width": "80vw",
      "max-height": "90%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "py-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
              default: _withCtx(() => [
                _cache[22] || (_cache[22] = _createElementVNode("div", null, [
                  _createElementVNode("div", null, "Member Analysis for the selected range:")
                ], -1)),
                _createElementVNode("div", null, [
                  _createVNode(_component_v_btn, {
                    left: "",
                    color: "primary",
                    class: "mr-4",
                    disabled: !_ctx.provider || _ctx.isSampleReport,
                    loading: _ctx.processingCSV,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.exportMemberCSV()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        small: "",
                        class: "mr-3"
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("fas fas fa-file-download", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[20] || (_cache[20] = _createTextVNode("Download ", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"]),
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    size: "small",
                    density: "comfortable",
                    variant: "flat",
                    icon: "",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.membersDialog = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { small: "" }, {
                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createTextVNode("fa fa-times", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_AppTable, {
                  "table-data": _ctx.membersTableData,
                  disableSort: true,
                  disablePagination: true,
                  "default-sort-column": [{ key: 'dataId', order: 'asc' }]
                }, null, 8, ["table-data"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "grey-darken-1",
                  variant: "text",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.membersDialog = false))
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode("Close", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.fetchingMembersAnalysis)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showLabelAbbreviation,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showLabelAbbreviation) = $event)),
      "onClick:outside": _cache[13] || (_cache[13] = ($event: any) => (_ctx.showLabelAbbreviation = false)),
      persistent: "",
      "max-width": "60vw"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, "Abbreviate Labels for " + _toDisplayString(_ctx.title) + " segmentation", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_v_form, { ref: "form" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.chartDataOptions).filter((a) => typeof _ctx.chartDataOptions[a].name === 'string'), (key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "label-abbr-row"
                        }, [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.title) + ":", 1),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.chartDataOptions[key].name), 1),
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.labelFormArray[_ctx.chartDataOptions[key].name],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.labelFormArray[_ctx.chartDataOptions[key].name]) = $event),
                            required: "",
                            variant: "underlined",
                            color: "primary",
                            class: "label-input"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_9, [
                        (_ctx.updatingLabels)
                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 0,
                              class: "mr-4",
                              indeterminate: "",
                              color: "primary"
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_btn, {
                          class: "mr-4",
                          color: "primary",
                          onClick: _ctx.updateLabelsAbbr,
                          disabled: _ctx.updatingLabels
                        }, {
                          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                            _createTextVNode(" Submit ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick", "disabled"]),
                        _createVNode(_component_v_btn, {
                          class: "mr-4",
                          onClick: _ctx.resetLabels,
                          disabled: _ctx.updatingLabels
                        }, {
                          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                            _createTextVNode(" Reset ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick", "disabled"]),
                        _createVNode(_component_v_btn, {
                          onClick: _ctx.closeLabelModal,
                          disabled: _ctx.updatingLabels
                        }, {
                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                            _createTextVNode("Close", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ])
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}